import React from 'react';
import { connect } from 'react-redux';
import {
  ListGroup,
  Row,
  Col,
} from 'react-bootstrap';

import {
  myAuctionsGet,
  pollMyAuctionsGet,
} from '../util/thunks';

import WinningAuction from './WinningAuction';
import LosingAuction from './LosingAuction';
import LostAuction from './LostAuction';
import WonAuction from './WonAuction';

class MyAuctions extends React.Component {

  componentWillMount() {
    this.props.myAuctionsGet();

    this.interval = setInterval(() => {
      this.props.pollMyAuctionsGet();
    }, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <div>

        <Row>
          {this.props.myAuctionsWinning.map(auction =>
            <Col xs={6} sm={4} md={3} key={auction.auctionIndex}>
              <WinningAuction auction={auction} />
            </Col>
          )}

          {this.props.myAuctionsLosing.map(auction =>
            <Col xs={6} sm={4} md={3} key={auction.auctionIndex}>
              <LosingAuction auction={auction} />
            </Col>
          )}
        </Row>

        <ListGroup>
          {this.props.myAuctionsUnclaimedLost.map(auction =>
            <LostAuction key={auction.auctionIndex} auction={auction} />
          )}
        </ListGroup>

        <ListGroup>
          {this.props.myAuctionsUnclaimedWon.map(auction =>
            <WonAuction key={auction.auctionIndex} auction={auction} />
          )}
        </ListGroup>

      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    myAuctionsWinning: state.myAuctions.winning,
    myAuctionsLosing: state.myAuctions.losing,
    myAuctionsUnclaimedLost: state.myAuctions.unclaimedLost,
    myAuctionsUnclaimedWon: state.myAuctions.unclaimedWon,
  };
};

const mapDispatchToProps = (dispatch) => ({

  myAuctionsGet: () => {
    return dispatch(myAuctionsGet());
  },

  pollMyAuctionsGet: () => {
    return dispatch(pollMyAuctionsGet());
  },

});

export default connect(mapStateToProps, mapDispatchToProps)(MyAuctions);



// WEBPACK FOOTER //
// ./src/components/MyAuctions.js